export default "__VITE_PUBLIC_ASSET__8b24d063__"